import type { MiddlewareFunction } from 'react-router';

import { usernameContext } from './context';
import { getCurrentUsername } from './getCurrentUsername';

/**
 * Fetches the current user's username and sets it in the username context along with the member id.
 */
export const usernameContextProvider: MiddlewareFunction = async ({
  context,
}) => {
  const usernameContextValue = await getCurrentUsername();
  context.set(usernameContext, usernameContextValue);
};
